export default __webpack_public_path__ + "static/media/map.3f0c9906.svg";